import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ViewColumnIcon from '@material-ui/icons/ViewColumn';
import CombinedChart from './CombinedChart';
import BidAskChart from './BidAskChart';
import ComparisonChart from './ComparisonChart';
import InventoryChangeChart from './InventoryChangeChart';
import VolumePieChart from './VolumePieChart';
import PriceIndex from './PriceIndex';
import ErrorBoundary from '../error/ErrorBoundary';
import { useAuth } from "../../context/auth";
import DataCover from '../display/DataCover';
import RackPriceHistoryChart from './RackPriceHistoryChart';

const analyticsElements = [
  {
    key: 'rackPriceHistory',
    label: 'Mills Rack Price',
    xs: 12,
    component: <RackPriceHistoryChart />,
  },
  {
    key: 'priceIndex',
    label: 'Price Index',
    xs: 12,
    component: <PriceIndex />,
  },
  {
    key: 'inventoryChange',
    label: 'Inventory Change',
    xs: 12,
    component: <InventoryChangeChart />,
  },
  {
    key: 'bidAsk',
    label: 'Bid Ask Spread',
    xs: 12,
    component: <BidAskChart />,
  },
  {
    key: 'combined',
    label: 'Combined Chart',
    xs: 12,
    component: <CombinedChart />,
  },
  {
    key: 'comparison',
    label: 'Comparison Chart',
    xs: 9,
    component: <ComparisonChart />,
  },
  {
    key: 'volume',
    label: 'Volume',
    xs: 3,
    component: <VolumePieChart />,
  },
];

const defaultVisibility = analyticsElements.reduce((acc, element) => {
  acc[element.key] = true;
  return acc;
}, {});

export default function Analytics() {
  const { dataSub, alphabbl } = useAuth();
  const [visibility, setVisibility] = useState(defaultVisibility);
  const [visibilityMenuAnchor, setVisibilityMenuAnchor] = useState(null);

  const openVisibilityMenu = (event) => {
    setVisibilityMenuAnchor(event.currentTarget);
  };

  const closeVisibilityMenu = () => {
    setVisibilityMenuAnchor(null);
  };

  const toggleElement = (key) => {
    setVisibility((current) => ({
      ...current,
      [key]: !current[key],
    }));
  };

  const setAllVisibility = (visible) => {
    setVisibility(analyticsElements.reduce((acc, element) => {
      acc[element.key] = visible;
      return acc;
    }, {}));
  };

  const visibleElements = analyticsElements.filter((element) => visibility[element.key]);

  const chartWrapper = (element) => {
    const locked = element.key === 'rackPriceHistory'
      ? false
      : element.key === 'inventoryChange'
      ? Number(alphabbl) !== 1
      : dataSub !== 1;

    return (
      <div style={{ position: 'relative' }}>
      {locked &&
        <DataCover />
      }
      {element.component}
    </div>
    );
  };

  return (
    <ErrorBoundary>
      <Grid container spacing={3} style={{ minWidth: 1000 }}>
        <Grid item xs={12}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<ViewColumnIcon />}
            onClick={openVisibilityMenu}
          >
            Show Charts
          </Button>
          <Menu
            anchorEl={visibilityMenuAnchor}
            open={Boolean(visibilityMenuAnchor)}
            onClose={closeVisibilityMenu}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          >
            <MenuItem
              onClick={() => setAllVisibility(true)}
            >
              <Typography color="primary">Select All</Typography>
            </MenuItem>
            <MenuItem
              onClick={() => setAllVisibility(false)}
            >
              <Typography color="primary">Deselect All</Typography>
            </MenuItem>
            {analyticsElements.map((element) => (
              <MenuItem
                key={element.key}
                onClick={() => toggleElement(element.key)}
              >
                <Checkbox
                  color="primary"
                  checked={visibility[element.key]}
                  readOnly
                  style={{ pointerEvents: 'none' }}
                />
                <span>{element.label}</span>
              </MenuItem>
            ))}
          </Menu>
        </Grid>
        {visibleElements.length === 0 && (
          <Grid item xs={12}>
            <Typography color="textSecondary" align="center">
              No analytics elements selected.
            </Typography>
          </Grid>
        )}
        {visibleElements.map((element) => (
          <Grid item xs={element.xs} key={element.key}>
            {chartWrapper(element)}
          </Grid>
        ))}
      </Grid>
    </ErrorBoundary>
  );
}
